<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/4a0H7H/OEBPS/images/9781449411350_cover.jpg?1705359744486" alt="This image is the cover for the book Like Mother, Like Daughter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Like Mother, Like Daughter
      </h1>
      <p class="bookDescription body article font2">
        <b>A hilarious celebration of the bond between mothers and daughters, featuring America’s favorite comic-strip heroine.</b><br/><br/>Written and illustrated by famous comic strip artist Cathy Guisewite, this book is a funny, touching little tribute to the unswerving influence of that tough taskmaster and best friend, of that woman who can turn pearls of wisdom into a choker—Mom.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Cathy Guisewite
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Andrews McMeel Publishing, LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1590908f